import React from 'react';
import { useTranslation } from 'react-i18next';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  DatePicker,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { createFilterCountry, createFilterSize } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter,
  trigerResetDatePicker
}) => {
  const { t } = useTranslation(['activity']);

  let companyCountry = [];
  let companySize = [];
  // let companyRegionCountry = [];

  const numberОfFilters = 4;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      // in cross filters after changing the date you need to get new filters
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateAlertCreatedAt = value => {
    const key = 'alertCreatedAt';
    checkAndSetFilter(key, value);
  };

  (function () {
    createFilterCountry(filters.country, companyCountry);
    createFilterSize(filters.companySize, companySize);
    // createFilterCountry(filters.regionCountry, companyRegionCountry);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.cloudProvider}
        input={{ value: filter.cloudProvider, onChange: handleFilter }}
        name={'cloudProvider'}
        label={t('activity:filters.CLOUD_PROVIDER')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.providerRegionName}
        input={{ value: filter.providerRegionName, onChange: handleFilter }}
        name={'providerRegionName'}
        label={t('activity:filters.PROVIDER_REGION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.maintenanceStatus}
        input={{ value: filter.maintenanceStatus, onChange: handleFilter }}
        name={'maintenanceStatus'}
        label={t('activity:filters.STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.ALERT_CREATED_AT')}
        input={{
          value: filter.alertCreatedAt,
          onChange: handleDateAlertCreatedAt
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
